<div class="park-meals">
  <h4 class="park-meals-title">Plan de Comidas</h4>

  <div class="park-meals-grid">
    <div class="park-meal" *ngFor="let c of cards; trackBy: trackByPlan" [class.selected]="c.plan === selectedPlan"
         [style.border-color]="c.plan === selectedPlan ? buttonColorActive : null">
      <img class="park-meal-img" [src]="basePath + 'meals/' + c.plan + '.jpg'" alt="{{ c.title }}" loading="lazy">

      <div class="park-meal-body">
        <div class="park-meal-head">
          <img class="park-meal-icon" [src]="basePath + 'icons/meal-' + c.plan + '.png'" alt="" aria-hidden="true">
          <p class="park-meal-name">{{ c.title }}</p>
        </div>

        <div class="park-meal-chips">
          <span *ngFor="let chip of c.chips">{{ chip }}</span>
        </div>

        <p class="park-meal-desc">{{ c.description }}</p>

        <ng-container *ngIf="c.includes.length; else noExtra">
          <p class="park-meal-includes-title">¿Qué Incluye?</p>
          <ul class="park-meal-includes">
            <li *ngFor="let inc of c.includes">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#111" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12.5l5 5L20 6.5"></path></svg>
              <span>{{ inc }}</span>
            </li>
          </ul>
        </ng-container>
        <ng-template #noExtra>
          <p class="park-meal-includes-title">Sin Costo Adicional</p>
        </ng-template>
      </div>

      <div class="park-meal-footer">
        <div>
          <p class="park-meal-amount">
            {{ currencyAgency?.code }} {{ c.extra | currencyConverterPure: c.currency: currencyAgency?.code: currencies | number: '1.2-2' }}
          </p>
          <p class="park-meal-amount-src" *ngIf="c.currency !== currencyAgency?.code">{{ c.currency }} {{ c.extra | number: '1.2-2' }}</p>
        </div>
        <button type="button" class="park-meal-btn" [style.background-color]="buttonColorActive"
                (click)="choose.emit({ plan: c.plan, offer: c.offer })">
          {{ c.plan === selectedPlan ? 'Seleccionado' : 'Seleccionar' }}
        </button>
      </div>
    </div>
  </div>
</div>
